// src/utils/queryParams.ts

export const getQueryParamValue = (
  search: string,
  paramName: string
): string | null => {
  const params = new URLSearchParams(search)
  return params.get(paramName)
}
